import { $getRoot, type EditorState } from 'lexical';

const getTextContent = (state: EditorState): string =>
  state.read(() => $getRoot().getTextContent());

export default getTextContent;
